export const SKILL_LEVELS = {
    JUNIOR: 'junior',
    MEDIOR: 'medior',
    SENIOR: 'senior',
};
export const SKILL_LEVEL_ORDER = ['junior', 'medior', 'senior'];
export const SKILL_TYPES = {
    SKI: 'ski',
    SNB: 'snb',
    WEX: 'wex',
    KID_SCHOOL: 'kid-school',
};
export const SKILL_TYPE_CONFIG = {
    [SKILL_TYPES.SKI]: { icon: 'ski.svg', label: 'Lyže' },
    [SKILL_TYPES.SNB]: { icon: 'snowboard.svg', label: 'Snowboard' },
    [SKILL_TYPES.WEX]: { icon: 'wex.svg', label: 'WEX' },
    [SKILL_TYPES.KID_SCHOOL]: { icon: 'kid-school.svg', label: 'Dětská školka' },
};
export const SKILL_LEVEL_LABELS = {
    [SKILL_LEVELS.JUNIOR]: 'Junior',
    [SKILL_LEVELS.MEDIOR]: 'Medior',
    [SKILL_LEVELS.SENIOR]: 'Senior',
};
export const SKILL_LEVEL_COLORS = {
    [SKILL_LEVELS.JUNIOR]: '#8B4513', // Dark copper
    [SKILL_LEVELS.MEDIOR]: '#5F5F5F', // Dark gray
    [SKILL_LEVELS.SENIOR]: '#B8860B', // Dark goldenrod
};
